import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-service-forms',
  templateUrl: './add-service-forms.component.html',
  styleUrls: ['./add-service-forms.component.css']
})
export class AddServiceFormsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
